export default __webpack_public_path__ + "static/media/arrow-left.63681bd6.svg";